import {view} from '@sail/ui';
import {FormattedMessage, useIntl, defineMessages} from 'react-intl';
import {useTheme} from '../../ThemeProvider';
import {useSales} from '../../SalesProvider';

const messages = defineMessages({
  defaultTitleMsg: {
    id: 'conversations_ui.support_conversations_client.support_conversations.client.dot_com.header.title.label',
    description: 'The title of the chat header',
    defaultMessage: 'Ask a question',
  },
  csatTitleMsg: {
    id: 'conversations_ui.support_conversations_client.support_conversations.client.dot_com.header.titleForCSAT.label',
    description: 'The title of the chat header for CSAT screen',
    defaultMessage: 'Share feedback',
  },
  salesOnlyTitleMsg: {
    id: 'conversations_ui.support_conversations_client.support_conversations.client.dot_com.header.salesOnlyTitleMsg.label',
    description: 'The title of the chat header for Sales-only chat',
    defaultMessage: 'Chat with sales',
  },
});

type Props = {
  isCSAT: boolean;
  isCSF: boolean;
};

export function DotComHeaderTitle({isCSAT, isCSF}: Props) {
  const intl = useIntl();
  const theme = useTheme();
  const {salesOnly} = useSales();

  let message = messages.defaultTitleMsg;
  if (isCSAT || isCSF) {
    message = messages.csatTitleMsg;
  } else if (salesOnly) {
    message = messages.salesOnlyTitleMsg;
  }

  const formattedTitle = <FormattedMessage {...message} />;

  return (
    <view.h3
      data-testid="conversations-widget-header-title"
      css={{
        font: 'label.large.emphasized',
        color: theme.onBrandTextColor,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      aria-label={intl.formatMessage(message)}
    >
      {formattedTitle}
    </view.h3>
  );
}
